import { createApp } from 'vue';
import BmpToJpgConverter from '../Components/BmpToJpgConverter.vue';

const root = document.getElementById('bmp-to-jpg-converter');
if (root) {
  createApp(BmpToJpgConverter).mount('#bmp-to-jpg-converter');
}
